import { Button, Cascader, message, Tooltip } from 'antd'
import React from 'react'
import withSpinning from '../../elements/HOC/withSpinning'
import { compose } from 'recompose'
import { strVal, unflatten } from '../../modules/Utils'
import CentersApi from '../../api/Corporates/Centers'

const Enhanced = compose(withSpinning)(Cascader)

class CentersCascader extends React.Component {
  state = {
    options: [],
    cached: [],
  }
  api = new CentersApi()

  fetch = async () => {
    try {
      this.setState({
        loading: true,
      })
      let data = await this.api.list(strVal(this.props, 'company'), strVal(this.props, 'category'))
      const mapped = unflatten(data)
      this.setState({
        options: mapped,
        loading: false,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        loading: false,
      })
    }
  }
  async componentDidMount() {
    await this.fetch()
  }

  render() {
    const { loading, options } = this.state
    return (
      <Tooltip
        placement="top"
        mouseEnterDelay={0.5}
        mouseLeaveDelay={0.5}
        overlayStyle={{ background: 'white' }}
        title={
          <Button
            style={{
              backgroundColor: 'Transparent',
              color: 'white',
            }}
            icon="retweet"
            onClick={this.fetch}>
            Refresh dropdown
          </Button>
        }
        trigger="hover">
        <Enhanced
          options={options}
          {...this.props}
          fieldNames={{ label: 'name', value: '_id', children: 'children' }}
          fetching={loading}
        />
      </Tooltip>
    )
  }
}

export default CentersCascader
